import React, { useState, useContext } from "react";
import {
    Alignment,
    Button,
    Classes,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    InputGroup
} from "@blueprintjs/core";

import SettingDrawer from "./SettingDrawer";

import { DarkThemeContext, NewTemplateDialogContext, SearchContext } from "../utils/context";
import { useHistory } from "react-router-dom";
import AvanadeLogo from "./AvanadeLogo";

type Props = { toggleTheme: () => void };

export default function NavBar({ toggleTheme }: Props) {
    const [open, setOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [, setCreateTemplateOpen] = useContext(NewTemplateDialogContext);
    const [search, setSearch] = useContext(SearchContext);
    const dark = useContext(DarkThemeContext);
    const history = useHistory();
    return (
        <div className="navbar-container">
            <Navbar className={"bp3-navbar"} fixedToTop>
                <NavbarGroup align={Alignment.LEFT} className="left-group">
                    <NavbarHeading>
                        <AvanadeLogo />
                    </NavbarHeading>
                    <NavbarDivider />

                    <Button
                        minimal
                        icon="document"
                        text="Templates"
                        active={activeIndex === 0}
                        outlined={false}
                        onClick={() => {
                            setActiveIndex(0);
                            history.push("/");
                        }}
                    />
                    <div className="template-add">
                        <Button
                            minimal
                            icon="add"
                            intent="primary"
                            onClick={() => {
                                setCreateTemplateOpen(true);
                            }}
                        />
                    </div>
                    {/* <NavbarDivider />
                    <Button
                        minimal
                        icon="history"
                        text="Runs"
                        active={activeIndex === 1}
                        onClick={() => {
                            setActiveIndex(1);
                            history.push("/runs");
                        }}
                    /> */}
                    <NavbarDivider />
                </NavbarGroup>
                <NavbarGroup align={Alignment.CENTER} className="center-group">
                    <InputGroup
                        className="search-input"
                        type="search"
                        value={search}
                        leftIcon="search"
                        fill={true}
                        onChange={e => {
                            setSearch(e.currentTarget.value);
                        }}
                        placeholder="Search"
                    />
                </NavbarGroup>

                <NavbarGroup align={Alignment.RIGHT} className="right-group">
                    {/* 
                     //!todo implement template export
                    <Button
                        className={Classes.MINIMAL}
                        icon="cloud-download"
                        text="Excel"
                        onClick={() => console.log("Implement Export")}
                    /> */}
                    <NavbarDivider />
                    <Button icon={dark ? "flash" : "moon"} minimal onClick={toggleTheme} />
                    <Button className={Classes.MINIMAL} icon="settings" onClick={() => setOpen(!open)} />
                </NavbarGroup>
            </Navbar>

            <SettingDrawer open={open} setOpen={setOpen} />
        </div>
    );
}
